export default "/images/d0dbe64dd74e6ea9440ffde1aed48201.avif";